import React from 'react';
import CurbsidePickupForm from './curbside-pickup-form';

const { UI, Order } = Mobi2Go;

Order.onReady(() => {
    const modal = UI.ExternalModal.create(
        'order-curbside-pickup-modal',
        <CurbsidePickupForm closeModal={() => modal.close()}/>,
        {
            'data-view': 'order-curbside-pickup-modal',
            className: 'm2g-order-curbside-pickup-modal',
        }
    )

    modal.mount();

    UI.bind('showCurbsidePickupModal', () => {
        modal.open();
    })
})